import React, { useState } from "react";
import { Button } from "@mui/material";
import PrintRoundedIcon from "@mui/icons-material/PrintRounded";
import { useAlert } from "../../../context/AlertContext";

export default function PrintOrder({
  ordenCreada,
  clienteReferencia,
  mesa,
  detalles,
  disabled = false,
  buttonSx,
}) {
  const { showError, showSuccess } = useAlert();
  const [printing, setPrinting] = useState(false);

  const buildSabor = (item) => {
    const nombre = item.sabor_nombre || item.nombre || "";
    const cantidad = Number(item.cantidad || 1);
    if (!nombre) return null;
    return {
      nombre,
      cantidad,
    };
  };

  const buildFruta = (item) => {
    const nombre = item.fruta_nombre || item.nombre || "";
    if (!nombre) return null;
    return {
      nombre,
    };
  };

  const buildDetalle = (detalle) => {
    const productoNombre =
      detalle.producto_nombre ||
      detalle.descripcion ||
      "";
    const payload = {
      producto_nombre: productoNombre,
      descripcion: detalle.descripcion || productoNombre,
      cantidad: Number(detalle.cantidad || 0),
    };
    const observacion = String(detalle.observacion || "").trim();
    const sabores = (detalle.sabores || [])
      .map(buildSabor)
      .filter(Boolean);
    const frutas = (detalle.frutas || [])
      .map(buildFruta)
      .filter(Boolean);
    if (observacion) {
      payload.observacion = observacion;
    }
    if (sabores.length) {
      payload.sabores = sabores;
    }
    if (frutas.length) {
      payload.frutas = frutas;
    }
    return payload;
  };

  const imprimirOrden = async () => {
    if (!ordenCreada?.id) {
      showError("Primero crea la orden.");
      return;
    }
    if (!detalles?.length) {
      showError("La orden no tiene productos para imprimir.");
      return;
    }
    try {
      setPrinting(true);
      const ordenParaImprimir = {
        id: ordenCreada.id,
        numero: ordenCreada.numero || ordenCreada.id,
        cliente_referencia:
          clienteReferencia ||
          ordenCreada.cliente_referencia ||
          "",
        mesa: mesa || ordenCreada.mesa || "",
        detalles: detalles.map(buildDetalle),
      };
      const response = await fetch("http://127.0.0.1:5050/print-order", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(ordenParaImprimir),
      });
      let data = {};
      try {
        data = await response.json();
      } catch {
        data = {};
      }
      if (!response.ok || !data.ok) {
        showError(
          data.error ||
            "No se pudo imprimir la orden."
        );
        return;
      }
      showSuccess("Orden enviada a impresión.");
    } catch {
      showError(
        "No se pudo conectar con el puente de impresión local."
      );
    } finally {
      setPrinting(false);
    }
  };

  return (
    <Button
      fullWidth
      variant="outlined"
      startIcon={<PrintRoundedIcon />}
      onClick={imprimirOrden}
      disabled={
        disabled ||
        printing ||
        !ordenCreada?.id ||
        !detalles?.length
      }
      sx={buttonSx}
    >
      {printing ? "Imprimiendo..." : "Imprimir"}
    </Button>
  );
}